import React from 'react';
import { func, shape, string, arrayOf } from 'prop-types';
import { connect } from 'react-redux';
import locationShape from 'propTypes/locationShape';
import { operations } from 'state/ducks/map';
import LocationMarker from 'components/Map/MapComponents/LocationMarker';

function isLocationActive({ location, segments, selectedId, hoveredId }) {
  // checks if the object.id matches one of the active states
  const idMatchesActiveStates = ({ id }) => id === hoveredId || id === selectedId;

  if (idMatchesActiveStates(location)) return true;

  // check wheter id a segment which is connected to the location
  const activeSegment = segments.find(idMatchesActiveStates);

  return (
    activeSegment && (activeSegment.from.id === location.id || activeSegment.to.id === location.id)
  );
}

export function LocationMarkerGroup({
  locations,
  segments,
  routeParams,
  currentHover,
  selectEntity,
  enterEntity,
  leaveEntity,
}) {
  // eslint-disable-next-line global-require
  const { FeatureGroup } = require('react-leaflet');
  const selectedId = routeParams.id;
  const hoveredId = currentHover && currentHover.id;

  return (
    <FeatureGroup>
      {locations.map(location => {
        const { id, trackingDevice, lat, lng, name } = location;

        const isActive = isLocationActive({
          location,
          segments,
          selectedId,
          hoveredId,
        });
        const isFaded = Boolean(selectedId && id !== selectedId);

        return (
          <LocationMarker
            key={`${id}`}
            trackingDevice={trackingDevice}
            position={[lat, lng]}
            name={name}
            id={id}
            onSelect={() => {
              selectEntity({
                id,
                type: 'location',
              });
            }}
            onEnter={() =>
              enterEntity({
                id,
                type: 'location',
              })}
            onLeave={() =>
              leaveEntity({
                id,
                type: 'location',
              })}
            isActive={isActive}
            isFaded={isFaded}
          />
        );
      })}
    </FeatureGroup>
  );
}

LocationMarkerGroup.propTypes = {
  locations: arrayOf(locationShape).isRequired,
  segments: arrayOf(
    shape({
      id: string.isRequired,
      from: shape({ name: string }).isRequired,
      to: shape({ name: string }).isRequired,
    })
  ).isRequired,
  selectEntity: func.isRequired,
  enterEntity: func.isRequired,
  leaveEntity: func.isRequired,
  routeParams: shape({
    id: string,
  }).isRequired,
  currentHover: shape({
    id: string.isRequired,
  }),
};

const mapStateToProps = ({ map }) => ({
  currentHover: map.currentHover,
});

export default connect(mapStateToProps, operations)(LocationMarkerGroup);



// WEBPACK FOOTER //
// ./src/components/Map/MapComponents/LocationMarkerGroup/index.js